// LocalizedDatePicker.tsx
import React, { useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { useTranslation } from 'react-i18next';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker';

import 'dayjs/locale/en';
import 'dayjs/locale/pl';
import 'dayjs/locale/uk';
import 'dayjs/locale/ro';
import 'dayjs/locale/ru';

interface LocalizedDatePickerProps extends DatePickerProps {
}

export const LocalizedDatePicker: React.FC<LocalizedDatePickerProps> = (props: LocalizedDatePickerProps) => {
  const { i18n } = useTranslation();
  
  return (
    <LocalizationProvider 
      dateAdapter={AdapterDayjs} 
      adapterLocale={i18n.language} // Динамическая смена языка (ru, en, etc.)
    >
      <DatePicker
        {...props}
        slotProps={{ 
          textField: { 
            size: "small", 
            fullWidth: true 
          } 
        }}
        // format="DD.MM.YYYY"
      />
    </LocalizationProvider>
  );
};